import { on } from 'delegated-events';

on('change', '.checkbox input', (event) => {
  const { currentTarget: $checkbox } = event;

  if ($checkbox.form) {
    const $$neighbour = $checkbox.form.elements.namedItem($checkbox.name);

    if ($$neighbour instanceof RadioNodeList) {
      $$neighbour.forEach(($neighbour) => {
        if (!($neighbour instanceof HTMLInputElement)) {
          return;
        }

        if ($checkbox.dataset.checkboxCheckAll !== undefined) {
          $neighbour.checked = $checkbox.checked;
        } else if ($neighbour.dataset.checkboxCheckAll !== undefined) {
          $neighbour.checked = Array.from($$neighbour)
            .filter(($n) => $n instanceof HTMLInputElement)
            .every(($n) => ($n !== $neighbour ? $n.checked : true));
        }
      });
    }
  }
});
